/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserControls from 'flarum/forum/utils/UserControls';
import app from 'flarum/forum/app';
import { slug } from '../../common';
import Button from 'flarum/common/components/Button';
const t = function () {
  return app.translator.trans(...arguments);
};
const prfx = `${slug}.forum.user.assign_achievement`;
export default function () {
  extend(UserControls, 'moderationControls', function (items, user) {
    if (!app.forum.attribute(`${slug}.gamification.enabled`)) {
      return;
    }
    if (app.session.user?.attribute('canAssignAchievement')) {
      items.add('assign-achievement', m(Button, {
        icon: "fas fa-user-tag",
        onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/achievements/components/AssignAchievementLevelModal', webpackMode: 'lazy-once' */ './components/AssignAchievementLevelModal'), {
          user: user
        })
      }, t(`${prfx}.control_label`)));
    }
  });
}flarum.reg.addChunkModule('352', '41', 'glowingblue-gamilytics', 'forum/achievements/components/AssignAchievementLevelModal');
flarum.reg.addChunkModule('352', '41', 'glowingblue-gamilytics', 'common/components/AchievementLevelSelector');
flarum.reg.addChunkModule('352', '41', 'glowingblue-gamilytics', 'common/states/AchievementLevelsState');